<template>
    <b-card-footer>
        <p>
            <small>
                <span class="mr-1">
                    {{ $t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE`) }}
                </span>
                <span>
                    {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Business Registration No`) }} <br />
                </span>
                <span class="mr-1">
                    {{ $t(`org.footer.${VUE_APP_NAMESPACE}.CEO`) }}
                </span>
                <span class="mr-1">
                    <a
                        class="mr-1"
                        :href="`${VUE_APP_AUTH_CENTER_URL}/privacy?locale=${locale}&theme=${skin}`"
                        target="_blank"
                        style="vertical-align:text-bottom"
                    >
                        {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Privacy Notice`) }}
                    </a>
                    <a
                        href="https://privacy.megazone.com/production/mzc/cctv/index.html"
                        target="_blank"
                        style="vertical-align:text-bottom"
                    >
                        {{ $t(`org.footer.${VUE_APP_NAMESPACE}.CCTV Notice`) }}
                    </a>
                </span>
            </small>
        </p>
        <!-- <p>
            <small>
            {{ $t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE B/D, 46, Nonhyeon-ro 85-gil, Gangnam-gu, Seoul, South Korea`) }} <br>
            {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Contact Call`) }} <br>
            {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Contact Email`) }} <br>
            </small>
        </p> -->
        <p>
            <small style="font-style:italic">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Copyright`) }}
            </small>
        </p>
    </b-card-footer>
</template>
<script>
import useAppConfig from '@core/app-config/useAppConfig'
import useEnvString from '@/composables/useEnvString'
import { ref } from '@vue/composition-api'
export default {
    setup () {
        const { skin } = useAppConfig()
        const {
            VUE_APP_NAMESPACE,
            VUE_APP_AUTH_CENTER_URL
        } = useEnvString()
        const locale = ref(localStorage.getItem('locale'))
        return {
            VUE_APP_NAMESPACE,
            VUE_APP_AUTH_CENTER_URL,
            skin,
            locale
        }
    }
}
</script>
